import {
  IconAnalytics,
  IconBinocularsGray,
  IconChartBar,
  IconClockGray,
  IconCoil,
  IconLayers,
  IconLocation,
  IconMeter,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconShareGray,
  IconWarning,
} from '@assets/images/icon';
import { rtlsSystem } from '@assets/images/solution';
import video from '@src/assets/images/solution/logisticsAsset/video/rtlsVideo.mp4';

import subVideo1 from '@src/assets/images/solution/logisticsAsset/video/sub/rtlsVideo1.mp4';
import subVideo2 from '@src/assets/images/solution/logisticsAsset/video/sub/rtlsVideo2.mp4';
import subVideo3 from '@src/assets/images/solution/logisticsAsset/video/sub/rtlsVideo3.mp4';
import subVideo4 from '@src/assets/images/solution/logisticsAsset/video/sub/rtlsVideo4.mp4';

import image1 from '@src/assets/images/solution/logisticsAsset/img/1.avif';
import image2 from '@src/assets/images/solution/logisticsAsset/img/2.avif';
import image3 from '@src/assets/images/solution/logisticsAsset/img/3.avif';
import image4 from '@src/assets/images/solution/logisticsAsset/img/4.avif';

export default {
  type: '物流解决方案',
  banner: {
    title: '自动记录仓库资产移动，实时控制出入库',
    desc: '自动追踪资产的出入库时间和移动路径，实现物流流程数字化，无需人工操作即可准确掌握库存并及时发现异常。',
  },

  video: {
    title: '通过精确的位置信息提升仓库运营效率',
    desc: '即使在复杂的物流仓库中，也能实时追踪每个资产的位置，最大化管理的准确性和效率。',
    play: video,
  },

  func: [
    {
      theme: '精准追踪并管理物流资产位置',
      title: '资产位置实时监控',
      desc: '即使在大型仓库内，也能将单个资产的位置精准掌握在±50cm内，实时查看资产状态和分布，实现快速准确的库存管理。',
      sub1: '提供高精度',
      icon1: IconRulerGray,
      sub2: '快速数据联动',
      icon2: IconShareGray,
      image: image1,
    },
    {
      title: '超小型贴纸标签简化管理',
      desc: '将超小型贴纸标签贴在资产上，提高管理便利性，适用于任何尺寸或形状的资产位置追踪。',
      sub1: '实时位置追踪',
      icon1: IconBinocularsGray,
      sub2: '提供高精度',
      icon2: IconRulerGray,
      image: image2,
    },
    {
      title: '适用于大规模资产管理的系统',
      desc: '可同时实时监控和管理1万件以上库存资产，在大规模物流环境下保证高效性。',
      sub1: '快速数据联动',
      icon1: IconShareGray,
      sub2: '实时状态掌握',
      icon2: IconClockGray,
      image: image3,
    },
    {
      title: '资产位置快速搜索与定位',
      desc: '通过强大的搜索功能，轻松快速定位所需资产，最大限度节省库存管理的时间和精力。',
      sub1: '快速数据联动',
      icon1: IconShareGray,
      sub2: '实时状态掌握',
      icon2: IconClockGray,
      video: subVideo3,
    },
    {
      theme: '利用资产数据提升运营效率，预防风险',
      title: '实时掌握出入库状况',
      desc: '实时监控出入库等所有物流状况，准确追踪物流移动，提前防止运营错误。',
      sub1: '快速数据联动',
      icon1: IconShareGray,
      sub2: '实时状态掌握',
      icon2: IconClockGray,
      video: subVideo4,
    },
    {
      title: '按仓库监控适当库存量',
      desc: '实时分析每个仓库的库存资产适当数量，优化空间使用，提前解决仓库空间不足问题。',
      sub1: '快速数据联动',
      icon1: IconShareGray,
      sub2: '实时状态掌握',
      icon2: IconClockGray,
      image: image4,
    },
    {
      title: '防止擅自带出与资产丢失警报',
      desc: '若发生资产擅自带出或超出指定时间带出，将立即发送警报，提前阻止资产丢失风险。',
      sub1: '快速数据联动',
      icon1: IconShareGray,
      sub2: '实时状态掌握',
      icon2: IconClockGray,
      video: subVideo1,
    },
    {
      title: '库存状态实时监控',
      desc: '可直观查看各区域及整体库存状态，支持准确的库存运营与快速决策。',
      sub1: '快速数据联动',
      icon1: IconShareGray,
      sub2: '实时状态掌握',
      icon2: IconClockGray,
      video: subVideo2,
    },
  ],

  subfunc: {
    title: '主要功能概览',
    desc: '',

    data: [
      {
        icon: IconLocation,
        title: '实时查看资产位置',
        desc: '实时准确查看仓库内所有资产的位置。',
      },
      {
        icon: IconCoil,
        title: '提供超小型贴纸标签',
        desc: '使用小型标签可轻松贴附于各类资产，实现位置追踪。',
      },
      {
        icon: IconLayers,
        title: '大规模资产同时管理',
        desc: '可同时实时管理1万件以上资产。',
      },
      {
        icon: IconSearch,
        title: '资产位置搜索功能',
        desc: '通过简单的搜索功能快速找到所需资产位置。',
      },
      {
        icon: IconRoute,
        title: '实时掌握出入库状况',
        desc: '实时准确监控入库和出库状况。',
      },
      {
        icon: IconChartBar,
        title: '按仓库分析适当库存量',
        desc: '分析每个仓库的库存量和空间余量，支持高效运营。',
      },
      {
        icon: IconWarning,
        title: '擅自带出自动警报',
        desc: '若发生擅自带出或超时移动，将立即发送警报。',
      },
      {
        icon: IconMeter,
        title: '实时查看库存状态',
        desc: '实时直观掌握仓库整体及区域库存状态。',
      },
      {
        icon: IconRoute,
        title: '记录资产移动路径',
        desc: '自动记录资产的移动路径并保存为数据。',
      },
      {
        icon: IconAnalytics,
        title: '基于资产数据生成报告',
        desc: '自动分析资产移动数据，定期提供管理报告。',
      },
    ],
  },

  system: {
    title: '系统结构',
    img: rtlsSystem,
  },

  productTitle: '产品组合',
  product: [
    {
      tag: 'assetPackage',
    },
    {
      tag: 'workerPackage',
    },
  ],

  contents: [
    {
      data: 'logisticsSafety',
    },
    {
      data: 'constructionAsset',
    },
    {
      data: 'blogRTLS',
    },
    {
      data: 'blogForklift',
    },
  ],
};
